import Box from '@mui/material/Box';
import { useLocation, Outlet } from 'react-router-dom';
import { Link } from 'react-router-dom';
import {
  gmailSettingsPages,
  pagesConfig,
} from '../../../../shared/pages-config';
import { useUserSettings } from '../../../../utils/use-user-settings';
import { isAbleToSeeUIElement } from '../../../../utils/roles/client-roles';
import { Messages } from '../../../../utils/message-constants';

import Card from '@mui/material/Card';
import Stack from '@mui/material/Stack';
import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import Tooltip from '@mui/material/Tooltip';

export default function GmailSettings() {
  const location = useLocation();
  const { userRoles, usersTier, isDefault } = useUserSettings();

  return (
    <Box flexDirection="row" sx={{ height: '100%', overflowY: 'auto' }}>
      <Stack
        flexDirection="row"
        gap={1}
        sx={{
          py: 2,
          height: '100%',
        }}
        justifyContent="space-between"
      >
        <Card
          sx={{
            minWidth: 230,
            overflowY: 'auto',
            maxHeight: 'fit-content',
          }}
        >
          <Tabs
            orientation="vertical"
            value={
              location.pathname.split('/')[4] ||
              pagesConfig.accountDelegation.link
            }
          >
            {gmailSettingsPages.map((page) => {
              const doesntHavePermission =
                !isAbleToSeeUIElement(userRoles, page.requiredPermission) &&
                page.requiredPermission !== '*';
              const doesntHaveTier = usersTier.rank < page.minimumTier;
              const shouldShowButDisabled = isDefault && doesntHaveTier;
              if (shouldShowButDisabled) {
                return (
                  <Tab
                    key={page.name}
                    value={page.link}
                    component={Link}
                    to={page.link}
                    label={
                      <Tooltip
                        title={Messages.Errors.Tier.Viewing(
                          page.minimumTierDisplayValue
                        )}
                        onClick={(e) => e.preventDefault()}
                        arrow
                      >
                        <span style={{ pointerEvents: 'auto' }}>
                          {page.name}
                        </span>
                      </Tooltip>
                    }
                    icon={<page.icon />}
                    iconPosition="start"
                    sx={{
                      minHeight: '40px',
                      height: '40px',
                      width: 'fit-content',
                    }}
                    disabled
                  />
                );
              }
              return (
                !(doesntHavePermission || doesntHaveTier) && (
                  <Tab
                    label={page.name}
                    value={page.link}
                    key={page.value}
                    component={Link}
                    to={page.link}
                  />
                )
              );
            })}
          </Tabs>
        </Card>

        <Box sx={{ flexGrow: 1, minWidth: 0, height: '100%' }}>
          <Outlet />
        </Box>
      </Stack>
    </Box>
  );
}
